import { Box, SvgIconProps, Typography } from '@mui/material';
import React from 'react';
import { SxProps } from '@mui/material';
import { ControlZoneSource, Healthcheck, ZONE_CONFIG } from 'domain/shared/newProject';
import { normalizeControlZone } from '../../controls/utils';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { Tooltip } from 'framework/ui/mui-builder';
import { StaffingRiskIssue } from 'domain/shared/staffing';

interface HealthcheckMessageProps {
  healthcheck?: Healthcheck | null;
  fallbackMessage?: string;
  isStaffingHealthcheck?: boolean;
  staffingRisksIssue?: StaffingRiskIssue | null;
  messageOverride?: string;
  zoneOverride?: ControlZoneSource;
  tooltipTitle?: string;
  sx?: SxProps;
}

const HealthcheckMessage: React.FC<HealthcheckMessageProps> = ({
  healthcheck,
  fallbackMessage = EMPTY_VALUE_INDICATOR,
  isStaffingHealthcheck = false,
  staffingRisksIssue,
  messageOverride,
  zoneOverride,
  tooltipTitle,
  sx,
}) => {
  const message = messageOverride ?? (isStaffingHealthcheck ? staffingRisksIssue?.description : healthcheck?.message);
  if (!message) {
    return (
      <Typography pr={3.5} sx={sx}>
        {fallbackMessage}
      </Typography>
    );
  }

  const targetZone = normalizeControlZone(
    zoneOverride ?? (isStaffingHealthcheck ? staffingRisksIssue?.targetPriority : healthcheck?.targetZone),
  );
  const config = targetZone ? ZONE_CONFIG[targetZone] : null;

  if (!config) {
    const content = <Typography sx={sx}>{message}</Typography>;
    return tooltipTitle ? <Tooltip title={tooltipTitle}>{content}</Tooltip> : content;
  }

  const Icon = config.icon;
  const content = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        ...sx,
      }}
    >
      <Typography color={config.color}>{message}</Typography>
      <Icon color={config.color as SvgIconProps['color']} sx={{ fontSize: '1.2rem' }} />
    </Box>
  );

  return tooltipTitle ? <Tooltip title={tooltipTitle}>{content}</Tooltip> : content;
};

export default HealthcheckMessage;
